import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box } from '@mui/material'

type Props = {
  expanded: boolean
  onToggle: () => void
}

export default function ExpandToggle({ expanded, onToggle }: Props) {
  return (
    <Box display="flex" alignItems="center" pt={0.4}>
      <Box
        sx={{
          borderRadius: 20,
          height: 25,
          cursor: 'pointer',
          '&:hover svg': {
            borderRadius: 20,
            backgroundColor: 'lightgrey',
            color: 'primary.main',
          },
        }}
        onClick={onToggle}>
        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Box>
    </Box>
  )
}
